import { render, staticRenderFns } from "./WPTextInfo.vue?vue&type=template&id=b35d0446"
import script from "./WPTextInfo.vue?vue&type=script&lang=ts"
export * from "./WPTextInfo.vue?vue&type=script&lang=ts"
import style0 from "./WPTextInfo.vue?vue&type=style&index=0&id=b35d0446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports